module.exports = __webpack_public_path__ + "img/restaurante-fondo.8b41f742.jpg";